import {component_tool, framework_tool} from "@/tool";
import moment from "moment";
import React from 'react';
import AuthVideo from "../../../face/class/classStudent/classStudentRemoteAuth/authVideo";
import AuthLiveTimes from "./authLiveTimes";

let {WizModal, WizNotice} = component_tool;

let {WizDataTable, WizIcon, WizButton, WizDivider, WizSurveyAudience, WizTypography, WizRow} = component_tool
let {WizAvatarUpload, ossFileUtils} = framework_tool

let ref;
let ref_;
//配置项
let componentName = 'interactLive'

const _columns = (data) => {
  const {userEmail} = data;
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    userEmail != null && userEmail != '' && userEmail != undefined ? {
      title: "资源账号",
      name: "userEmail",
      dataIndex: "userEmail",
      searchItem: {
        type: 'custom',
        render: () => {
          return <span>{userEmail}</span>
        }
      },
    } : {},
    {
      title: "直播名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "直播类型",
      name: "liveType",
      dataIndex: "liveType",
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        {code: 1, codeName: "视频直播"},
        // { code: 2, codeName: "互动直播" },
        // { code: 3, codeName: "点播" },
        {code: 4, codeName: "远程认证"},
        {code: 5, codeName: "直播课堂"},
        {code: 6, codeName: "远程评估"},
        {code: 7, codeName: "企微会议"},
        {code: 8, codeName: "企微直播"},
      ],
    },
    {
      title: "观看类型",
      name: "watchType",
      dataIndex: "watchType",
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        {code: 1, codeName: "横屏"},
        {code: 2, codeName: "竖屏"},
      ],
    },
    {
      title: "直播分类",
      name: "categoryName",
      dataIndex: "categoryName",
      tableItem: {}
    },
    {
      title: "开播时间",
      name: "startDate",
      dataIndex: "startDate",
      width: 150,
      tableItem: {}
    },
    {
      title: "直播状态",
      name: "state",
      dataIndex: "state",
      tableItem: {},
      dict: [
        {code: 1, codeName: "草稿"},
        {code: 2, codeName: "预告中"},
        {code: 3, codeName: "直播中"},
        {code: 4, codeName: "已结束"}
      ],
      searchItem: {
        type: "select"
      },
    },
    {
      title: "开播时间",
      name: "searchDate",
      dataIndex: "searchDate",
      searchItem: {
        type: 'date~',
        showTime: true,
        format: 'YYYY-MM-DD HH:mm:ss'
      }
    }
  ];
};

const templateConfig = (data) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: _columns(data),
        btnAccessCheck: false,
        searchBarProps: {
          dataFormat: (val) => {
            if (val['searchDate'] && val['searchDate'].length === 2) {
              val['startDate'] = moment(val['searchDate'][0]).format("YYYY-MM-DD HH:mm:ss")
              val['endDate'] = moment(val['searchDate'][1]).format("YYYY-MM-DD HH:mm:ss")
            }
            return val
          },
          buttonSort: ["exportLiveInfo"],
          buttons: [
            {
              key: "exportLiveInfo",
              custom: true,
              params: {icon: 'export', children: '导出直播信息', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export"
                },
                formatParams: (rows, record, filter) => {
                  return {...filter};
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['videoPlayback', 'authLiveTimes', 'viewTrainingRecords', 'exportLiveRecordDetail'],
        rowOperateView: [
          {
            key: "viewTrainingRecords",
            custom: true,
            params: {children: "查看参训记录"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/live/liveList/LiveRecordList"
              }
            }
          },
          {
            key: "videoPlayback",
            custom: true,
            params: {children: "录像回放"},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "playbackModal",
                modalParams: {
                  title: "录像回放",
                  diy: (e) => {
                    e.record = Object.assign({}, e.record);
                    return (
                      <AuthVideo
                        key={'authVideo-' + e.record.id}
                        {...e}
                        type={0}
                        ref={r => {
                          ref_ = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  footer: null,
                  width: 700
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: (record, rows) => {
              let result = {disabled: true};
              let liveType = record.record.liveType
              let state = record.record.state
              //已结束 才有
              if (state === 4) {
                result.disabled = false
              }
              return result
            },
          },
          {
            key: "authLiveTimes",
            custom: true,
            params: {children: "直播场次"},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "authLiveTimesModal",
                modalParams: {
                  title: "直播场次",
                  diy: (e) => {
                    e.record = Object.assign({}, e.record);
                    return (
                      <AuthLiveTimes
                        key={'authLiveTimes-' + e.record.id}
                        {...e}
                        type={0}
                        ref={r => {
                          ref_ = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  footer: null,
                  width: 700
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: (record, rows) => {
              let result = {disabled: true};
              let liveType = record.record.liveType
              let state = record.record.state
              //进行中和已结束 才有
              if (state === 3 || state === 4) {
                result.disabled = false
              }
              return result
            },
          },
          {
            key: "exportLiveRecordDetail",
            custom: true,
            params: {icon: 'export', children: '导出参训明细', type: 'export'},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "exportLiveRecordDetail"
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: (record, rows) => {
              let result = {disabled: true};
              let liveType = record.record.liveType
              let state = record.record.state
              //进行中和已结束 才有
              if (state === 3 || state === 4) {
                result.disabled = false
              }
              return result
            },
          },
        ],
        commonOperate: {}
      }
    }
  };
};

const apis = (data) => {
  const {interactLiveResourcesId} = data;
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {pageNum: 1, pageSize: 10, interactLiveResourcesId}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {interactLiveResourcesId}
      }
    },
    exportLiveRecordDetail: {
      path: `${componentName}/exportInteractLiveRecordDetail`,
      payload: {
        key: `${componentName}@exportInteractLiveRecordDetail`,
        apiParams: {interactLiveResourcesId}
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  const {interactLiveResourcesId} = args;
  return {
    apis: apis({interactLiveResourcesId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
